import { Component } from '@angular/core';

@Component({
  selector: 'app-ixh25',
  templateUrl: './ixh25.component.html',
  styleUrl: './ixh25.component.css'
})
export class Ixh25Component {

}
